export default "/images/arrow-down-fat.svg?5e33dc55349ccba55dd9498d232071ce";